const state = {
  isDarkMode: localStorage.getItem('darkMode') === 'true'
};

const getters = {
  isDarkMode: state => state.isDarkMode
};

const mutations = {
  toggleDarkMode(state) {
    state.isDarkMode = !state.isDarkMode;
    localStorage.setItem('darkMode', state.isDarkMode);
  },
  setDarkMode(state, value) {
    state.isDarkMode = value;
    localStorage.setItem('darkMode', value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
}; 